export default __webpack_public_path__ + "494dd6a550846d4704b10dac690c075e.svg";